module.exports = __webpack_public_path__ + "img/8.26d3e747.png";